// ID del formulario de Tally (https://tally.so/r/xVrMMd).
export const tallyFormId = 'xVrMMd'

// Dirección del servicio de verificación que confirma con la API de Tally que el envío existe.
// Mientras esté vacía, el evento Lead NO se envía (nunca se confía solo en el parámetro sid).
// Esta URL es pública a propósito: la clave de Tally vive solo como secreto dentro del Worker.
export const leadVerificationEndpoint = 'https://jseefect-lead.vargassebastian540.workers.dev'
